import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/Images/icono-realtor.png'
import _imports_1 from '../../assets/Images/logo2.png'
import _imports_2 from '../../assets/Images/icono-titulo.png'
import _imports_3 from '../../assets/Images/logoRealtorToolsHeader2.png'
import _imports_4 from '../../assets/Images/Videos/video-company.mp4'
import _imports_5 from '../../assets/Images/icono-instector.png'
import _imports_6 from '../../assets/Images/Videos/video-inspector_1.mp4'


const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "content-dashboard"
}
const _hoisted_4 = {
  class: "modal fade modal-xl",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "modal-dialog" }
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "tw-text-center tw-text-2xl" }
const _hoisted_10 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_11 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "text-center"
    }, "SECTIONS")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Status")
  ])
], -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "content-dashboard__section-header" }
const _hoisted_18 = { class: "content-dashboard__section-header__logo1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "content-dashboard__section-header__logo2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "content-dashboard__section-video" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "content-dashboard__section-video__info-video" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-question-circle" }),
    /*#__PURE__*/_createElementVNode("span", null, "Overview video of the Realtor account"),
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "btn btn-primary"
    }, "WATCH VIDEO")
  ])
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_23 = { class: "reportes mb-5" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "reportes__tittle" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Reports")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_26 = { class: "reports__section1 tw-justify-center" }
const _hoisted_27 = { class: "reports__section1__options" }
const _hoisted_28 = { class: "input-group mb-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text",
    for: "select01"
  }, " ACTOR TYPE ")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", {
  value: '',
  selected: ""
}, "Choose...", -1)
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "reports__section1__options" }
const _hoisted_33 = { class: "input-group mb-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text",
    for: "select01"
  }, " ESTATE ")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", {
  value: '',
  selected: ""
}, "Choose...", -1)
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "reports__section1__options" }
const _hoisted_38 = { class: "input-group mb-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text",
    for: "select01"
  }, " COUNTY ")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", {
  value: '',
  selected: ""
}, "Choose state...", -1)
const _hoisted_41 = ["value"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "reports__section2 tw-justify-center" }
const _hoisted_45 = { class: "reports__section1__options" }
const _hoisted_46 = { class: "input-group mb-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text",
    for: "select01"
  }, " SECTION-ZONE ")
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("option", {
  value: '',
  selected: ""
}, "Choose county...", -1)
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "reports__section1__options" }
const _hoisted_51 = { class: "input-group mb-3" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text",
    for: "select01"
  }, " ZIP-CODE ")
], -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("option", {
  value: '',
  selected: ""
}, "Choose section...", -1)
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "reports__section1__options" }
const _hoisted_56 = { class: "input-group mb-3" }
const _hoisted_57 = { class: "reports__button d-flex justify-content-center" }
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<hr><div class=\"reports__export d-flex justify-content-end\"><select name=\"select\"><option value=\"value1\" selected>Export</option><option value=\"value2\">PDF</option><option value=\"value3\"><i class=\"fas fa-file-excel\"></i>EXCEL</option></select></div>", 2)
const _hoisted_60 = { class: "reports__data mt-3 pb-3 position-relative" }
const _hoisted_61 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_62 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ZIP-CODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ROLE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CREATED AT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "STATUS")
  ])
], -1)
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "" }
const _hoisted_66 = { class: "tw-overflow-hidden tw-whitespace-nowrap tw-flex tw-text-ellipsis tw-break-all tw-truncate" }
const _hoisted_67 = { class: "flex items-center" }
const _hoisted_68 = ["onUpdate:modelValue", "onChange"]
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { class: "tw-flex tw-justify-center pb-3" }
const _hoisted_73 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_74 = { class: "content-dashboard" }
const _hoisted_75 = /*#__PURE__*/_createStaticVNode("<div class=\"content-dashboard__section-header pt-4 px-4\"><div class=\"content-dashboard__section-header__logo1 p-0\"><img src=\"" + _imports_2 + "\" alt=\"\"><span>TITTLE COMPANY</span></div><div class=\"content-dashboard__section-header__logo2 p-0\"><img src=\"" + _imports_3 + "\" alt=\"\"></div></div><div class=\"content-dashboard__section-video px-4 tw-justify-between\"><div class=\"btn btn-pimary tw-flex tw-items-center tw-rounded-full tw-gap-2 tw-bg-[#FFF] tw-text-[#00A0DA] tw-font-medium tw-border-[#00A0DA]\" data-bs-toggle=\"modal\" data-bs-target=\"#exampleModalSupport\"><button>SUPPORT</button><i class=\"fas fa-user-cog tw-text-[#00A0DA]\"></i></div></div>", 2)
const _hoisted_77 = {
  class: "modal fade modal-l",
  id: "exampleModalSupport",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_78 = { class: "modal-dialog" }
const _hoisted_79 = { class: "modal-content" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_81 = { class: "modal-body" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "table-mlo w-100 bg-white p-3 rounded-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" If you have difficulty using it, add any criteria, or have any questions or topics, send us a message. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" We will respond to you as soon as possible.")
  ])
], -1)
const _hoisted_83 = {
  class: "textarea tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center",
  style: {"border":"1px solid #E6E7E8"}
}
const _hoisted_84 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_85 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_86 = ["disabled"]
const _hoisted_87 = {
  class: "modal fade",
  id: "exampleModal1",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel1",
  "aria-hidden": "true"
}
const _hoisted_88 = { class: "modal-dialog modal-xl" }
const _hoisted_89 = { class: "modal-content" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_91 = { class: "modal-body" }
const _hoisted_92 = {
  key: 0,
  src: _imports_4,
  class: "tw-w-full",
  controls: "",
  autoplay: ""
}
const _hoisted_93 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex\"><button id=\"openNoteModalTc\" class=\"btn tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold ms-auto mt-2 me-4\" style=\"border:none;\" data-bs-toggle=\"modal\" data-bs-target=\"#note-Modal-Tc\">SEE NOTE</button></div><div class=\"modal\" id=\"note-Modal-Tc\" tabindex=\"-1\" aria-hidden=\"true\" aria-labelledby=\"label-modal-1\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-body\"><h3 class=\"text-center\"><b>Note:</b></h3><br><p class=\"text-center\"><b>The title company must provide a percentage breakdown of the estimated charges related to its services and legally required payments.</b><br><br><b>The following must be excluded:</b><br> • Fees<br> • Mortgage Loan Originator charges (including underwriting commission)<br> • Broker fee<br><br><b>Please note:</b> The prorated amounts for taxes, insurance, homeowners’ association dues, and other similar items do not impact the mathematical and financial calculations performed by the <b>REALTORS®</b> within the applications. </p><br><div class=\"d-flex justify-content-end\"><button id=\"closeNoteModal\" type=\"button\" class=\"btn tw-bg-[#00a0da] tw-text-[#FFFFFF] tw-rounded-full tw-w-[150px]\" data-bs-dismiss=\"modal\" aria-label=\"Close\"> CLose </button></div></div></div></div></div>", 2)
const _hoisted_95 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_96 = { class: "content-dashboard" }
const _hoisted_97 = /*#__PURE__*/_createStaticVNode("<div class=\"content-dashboard__section-header pt-4 px-4\"><div class=\"content-dashboard__section-header__logo1 p-0\"><img src=\"" + _imports_5 + "\" alt=\"\"><span>INSPECTOR</span></div><div class=\"content-dashboard__section-header__logo2 p-0\"><img src=\"" + _imports_3 + "\" alt=\"\"></div></div><div class=\"content-dashboard__section-video px-4 tw-justify-between\"><div class=\"btn btn-pimary tw-flex tw-items-center tw-rounded-full tw-gap-2 tw-bg-[#FFF] tw-text-[#00A0DA] tw-font-medium tw-border-[#00A0DA] tw-mr-3 ms-auto\" data-bs-toggle=\"modal\" data-bs-target=\"#exampleModalSupport\"><button>SUPPORT</button><i class=\"fas fa-user-cog tw-text-[#00A0DA]\"></i></div></div>", 2)
const _hoisted_99 = {
  class: "modal fade modal-l",
  id: "exampleModalSupport",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_100 = { class: "modal-dialog" }
const _hoisted_101 = { class: "modal-content" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_103 = { class: "modal-body" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "table-mlo w-100 bg-white p-3 rounded-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" If you have difficulty using it, add any criteria, or have any questions or topics, send us a message. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" We will respond to you as soon as possible.")
  ])
], -1)
const _hoisted_105 = {
  class: "textarea tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center",
  style: {"border":"1px solid #E6E7E8"}
}
const _hoisted_106 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_107 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_108 = ["disabled"]
const _hoisted_109 = {
  class: "modal fade",
  id: "exampleModal2",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel1",
  "aria-hidden": "true"
}
const _hoisted_110 = { class: "modal-dialog modal-xl" }
const _hoisted_111 = { class: "modal-content" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_113 = { class: "modal-body" }
const _hoisted_114 = {
  key: 0,
  src: _imports_6,
  class: "tw-w-full",
  controls: "",
  autoplay: ""
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_116 = {
  key: 2,
  class: "position-relative"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResidentialView = _resolveComponent("ResidentialView")!
  const _component_ng_template = _resolveComponent("ng-template")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_loading = _resolveComponent("loading")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_TitleCompanyTables = _resolveComponent("TitleCompanyTables")!
  const _component_InspectorDashboard = _resolveComponent("InspectorDashboard")!
  const _component_Primary = _resolveComponent("Primary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_ctx.userRole == 'Realtor')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_ResidentialView)
          ]))
        : _createCommentVNode("", true),
      (_ctx.userRole == 'Admin')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.params.country) + " - Sections", 1),
                    (_ctx.listSections.length > 0)
                      ? (_openBlock(), _createBlock(_component_ng_template, { key: 0 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("table", _hoisted_11, [
                                _hoisted_12,
                                (_ctx.listSections.length > 0)
                                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSections, (section) => {
                                        return (_openBlock(), _createElementBlock("tr", null, [
                                          _createElementVNode("td", {
                                            class: _normalizeClass({ 'tw-bg-[#8EFF5E] tw-text-dark': section.full, 'tw-bg-[#FFF]': !section.full })
                                          }, _toDisplayString(section.name.replace("Seccion", "Section ")), 3),
                                          _createElementVNode("td", {
                                            class: _normalizeClass({ 'tw-bg-[#8EFF5E] tw-text-dark': section.full, 'tw-bg-[#FFF]': !section.full })
                                          }, _toDisplayString(section.full ? "Full" : "Empty"), 3)
                                        ]))
                                      }), 256))
                                    ]))
                                  : (_openBlock(), _createElementBlock("tbody", _hoisted_14, _hoisted_16))
                              ])
                            ]),
                            _createVNode(_component_ng_template)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("span", null, _toDisplayString(_ctx.userRole), 1)
              ]),
              _hoisted_20
            ]),
            _hoisted_21,
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _withDirectives(_createElementVNode("select", {
                      class: "custom-select",
                      id: "select01",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.usertype) = $event))
                    }, [
                      _hoisted_30,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRoles, (role) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: role.idRole
                        }, _toDisplayString(role.name), 9, _hoisted_31))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, _ctx.params.usertype]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _withDirectives(_createElementVNode("select", {
                      class: "custom-select",
                      id: "select01",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.state) = $event)),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getCountries()))
                    }, [
                      _hoisted_35,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStates, (state) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: state.name
                        }, _toDisplayString(state.name), 9, _hoisted_36))
                      }), 256))
                    ], 544), [
                      [_vModelSelect, _ctx.params.state]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _withDirectives(_createElementVNode("select", {
                      class: "custom-select tw-rounded-br-full tw-rounded-tr-full",
                      id: "select01",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.country) = $event)),
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getCountySections()))
                    }, [
                      _hoisted_40,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCountries, (country) => {
                        return (_openBlock(), _createElementBlock("option", { value: country }, _toDisplayString(country), 9, _hoisted_41))
                      }), 256))
                    ], 544), [
                      [_vModelSelect, _ctx.params.country]
                    ]),
                    (_ctx.params.country && _ctx.listSections.length > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "tw-pl-2",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#exampleModal",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getSections()))
                        }, _hoisted_43))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _withDirectives(_createElementVNode("select", {
                      class: "custom-select",
                      id: "select01",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.params.section) = $event)),
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadZipCodes()))
                    }, [
                      _hoisted_48,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSections, (section) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: section.name
                        }, _toDisplayString(section.name), 9, _hoisted_49))
                      }), 256))
                    ], 544), [
                      [_vModelSelect, _ctx.params.section]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _withDirectives(_createElementVNode("select", {
                      class: "custom-select",
                      id: "select01",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.params.zipcode) = $event))
                    }, [
                      _hoisted_53,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listZipCodes, (zipcode) => {
                        return (_openBlock(), _createElementBlock("option", { value: zipcode }, _toDisplayString(zipcode), 9, _hoisted_54))
                      }), 256))
                    ], 512), [
                      [_vModelSelect, _ctx.params.zipcode]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_datepicker, {
                      "auto-apply": "",
                      class: "tw-w-full",
                      range: "",
                      format: _ctx.formatDate,
                      "text-input": _ctx.configDatePicker,
                      modelValue: _ctx.configDatePicker.date,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                      placeholder: "Enter date range..."
                    }, null, 8, ["format", "text-input", "modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getUsers()))
                }, "GENERATE")
              ]),
              _hoisted_58,
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_component_loading, {
                  active: _ctx.loaderConfig.isLoading,
                  "onUpdate:active": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
                  "can-cancel": false,
                  loader: 'dots',
                  "is-full-page": !_ctx.loaderConfig.fullPage
                }, null, 8, ["active", "is-full-page"]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("table", _hoisted_62, [
                    _hoisted_63,
                    (_ctx.listUsers && _ctx.listUsers.length > 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_64, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUsers, (user) => {
                            return (_openBlock(), _createElementBlock("tr", null, [
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_65, _toDisplayString(user.idrol != 5 ? user.username + "" + user.lastname :
                                                user.companyname), 1)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(user.phonenumber), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_66, _toDisplayString(user.email), 1)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(user.zipcode), 1),
                              _createElementVNode("td", null, _toDisplayString(user.tipo_rol), 1),
                              _createElementVNode("td", null, _toDisplayString(user.createdOn), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_67, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "link-checkbox",
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => ((user.active) = $event),
                                    onChange: ($event: any) => (_ctx.changeStatus(user)),
                                    class: "tw-w-4 tw-h-4 tw-text-blue-600 tw-bg-gray-100 tw-border-gray-300 tw-rounded tw-focus:ring-blue-500 tw-dark:focus:ring-blue-600 tw-dark:ring-offset-gray-800 tw-focus:ring-2 tw-dark:bg-gray-700 tw-dark:border-gray-600"
                                  }, null, 40, _hoisted_68), [
                                    [_vModelCheckbox, user.active]
                                  ])
                                ])
                              ])
                            ]))
                          }), 256))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.listUsers && _ctx.listUsers.length == 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_69, _hoisted_71))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createVNode(_component_v_pagination, {
                  modelValue: _ctx.params.page,
                  "onUpdate:modelValue": [
                    _cache[12] || (_cache[12] = ($event: any) => ((_ctx.params.page) = $event)),
                    _ctx.getUsers
                  ],
                  pages: _ctx.params.pages,
                  "range-size": _ctx.params.pageSize,
                  "active-color": "#DCEDFF"
                }, null, 8, ["modelValue", "pages", "range-size", "onUpdate:modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.userRole == 'Title Company')
      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
          _createVNode(_component_loading, {
            active: _ctx.loaderConfig.isLoading,
            "onUpdate:active": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
            "can-cancel": false,
            loader: 'dots',
            "is-full-page": !_ctx.loaderConfig.fullPage
          }, null, 8, ["active", "is-full-page"]),
          _createElementVNode("div", _hoisted_74, [
            _hoisted_75,
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _hoisted_80,
                  _createElementVNode("div", _hoisted_81, [
                    _hoisted_82,
                    _createElementVNode("div", _hoisted_83, [
                      _withDirectives(_createElementVNode("textarea", {
                        name: "",
                        id: "",
                        cols: "30",
                        rows: "9",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.supportMessage.message) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.supportMessage.message]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("button", {
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submitReport($event))),
                        type: "button",
                        disabled: !_ctx.supportMessage.message,
                        class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
                      }, " SEND MESSAGE", 8, _hoisted_86)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _hoisted_90,
                  _createElementVNode("div", _hoisted_91, [
                    (_ctx.videoTutorial1)
                      ? (_openBlock(), _createElementBlock("video", _hoisted_92))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _hoisted_93,
            _createVNode(_component_TitleCompanyTables, {
              userID: _ctx.userSession.iduser
            }, null, 8, ["userID"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.userRole == 'Inspector')
      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
          _createVNode(_component_loading, {
            active: _ctx.loaderConfig.isLoading,
            "onUpdate:active": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
            "can-cancel": false,
            loader: 'dots',
            "is-full-page": !_ctx.loaderConfig.fullPage
          }, null, 8, ["active", "is-full-page"]),
          _createElementVNode("div", _hoisted_96, [
            _hoisted_97,
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _hoisted_102,
                  _createElementVNode("div", _hoisted_103, [
                    _hoisted_104,
                    _createElementVNode("div", _hoisted_105, [
                      _withDirectives(_createElementVNode("textarea", {
                        name: "",
                        id: "",
                        cols: "30",
                        rows: "9",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.supportMessage.message) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.supportMessage.message]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_106, [
                    _createElementVNode("div", _hoisted_107, [
                      _createElementVNode("button", {
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.submitReport($event))),
                        type: "button",
                        disabled: !_ctx.supportMessage.message,
                        class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
                      }, " SEND MESSAGE", 8, _hoisted_108)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("div", _hoisted_111, [
                  _hoisted_112,
                  _createElementVNode("div", _hoisted_113, [
                    (_ctx.videoTutorial2)
                      ? (_openBlock(), _createElementBlock("video", _hoisted_114))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _hoisted_115,
            _createVNode(_component_InspectorDashboard)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.userRole == 'MLO')
      ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
          _createVNode(_component_loading, {
            active: _ctx.loaderConfig.isLoading,
            "onUpdate:active": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
            "can-cancel": false,
            loader: 'dots',
            "is-full-page": !_ctx.loaderConfig.fullPage
          }, null, 8, ["active", "is-full-page"]),
          _createVNode(_component_Primary)
        ]))
      : _createCommentVNode("", true)
  ]))
}